export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class ProductNotFoundError extends Error {
  override readonly name = 'ProductNotFoundError';
  constructor() {
    super('Product not found');
  }
}

export class ProductAlreadyExistsError extends Error {
  override readonly name = 'ProductAlreadyExistsError';
  constructor() {
    super('Product already exists');
  }
}

export class ProductNotEditableError extends Error {
  override readonly name = 'ProductNotEditableError';
  constructor() {
    super('Product is not editable');
  }
}

export class InvalidProductInputError extends Error {
  override readonly name = 'InvalidProductInputError';
  constructor(message = 'Invalid product input') {
    super(message);
  }
}

export class InvalidNutritionLabelImageError extends Error {
  override readonly name = 'InvalidNutritionLabelImageError';
  constructor() {
    super('Invalid nutrition label image');
  }
}

export type ProductError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | ProductNotFoundError
  | ProductAlreadyExistsError
  | ProductNotEditableError
  | InvalidProductInputError
  | InvalidNutritionLabelImageError;
